import {PresupuestoComponent} from '../../../componentes/01-presupuesto/presupuesto/presupuesto.component';
import {ClsUtil} from '../../../util/cls-util';
import {GenericoService} from '../../../core/services/generico.service';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../core/services/app-info.service';
import {ClsPeticionPresupuestos} from '../../../core/models/peticiones/cls-pr-generico';
import {ClsCatalogosExpIns} from 'src/app/core/models/cls-catalogo-general';
import {ClsConceptosPartida} from "../../../core/models/cls-partida";
import {ClsErrores} from "../../../core/models/cls-errores";
import {inject} from "@angular/core";

export class ClsObjPresupuesto {
  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);

  constructor() {
  }

  public inicializarComponenteComoMaestro(component: PresupuestoComponent, maestro: boolean) {
    if (maestro || !this.infApp.mostrarexpinsacoplado) {
      component.paneTopSize = '100%';
      component.paneBottomSize = '0%';
    } else {
      component.paneTopSize = '64%';
      component.paneBottomSize = '35%';
    }
    component.ExpInsumoAcoplado.inicialarComoMaestro(maestro);
  }

  /**
   * Este metodo descomprime presupuesto: ClsUtil.descomprimirArchivoBase64(presupuestosZip, 'Presupuesto.txt');
   * @param presupuestosZip recibe la data de presupuesto
   * @param mapCatalogo recibe el catalogo en map para hacer mas rapido la busqueda
   */
  public async crearObjPresupuesto(presupuestosZip: string, mapCatalogo: Map<bigint, ClsCatalogosExpIns>): Promise<ClsConceptosPartida[]> {
    const conceptosPartidas: ClsConceptosPartida[] = [];
    try {
      const contenido: string = await ClsUtil.descomprimirArchivoBase64(presupuestosZip, 'Presupuesto.txt');
      if (ClsUtil.esNulo(contenido)) {
        return conceptosPartidas;
      }
      const objConceptos: string[] = ClsUtil.splitEnterNeo(contenido);
      objConceptos.forEach(item => {
        const concepto: ClsConceptosPartida = new ClsConceptosPartida();
        const filas: string[] = ClsUtil.splitTabsNeo(item);
        const catalogo: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(filas[2]));
        concepto.IdPresupuestoPartida = ClsUtil.bigintX(filas[0]);
        concepto.Partida = ClsUtil.cadenaX(filas[1]);
        concepto.IdCatalogo = ClsUtil.bigintX(filas[2]);
        concepto.Nivel = Number(catalogo.Nivel);
        concepto.Renglon = Number(filas[3]);
        concepto.Control = Number(filas[4]);
        concepto.Codigo = ClsUtil.cadenaX(catalogo.Codigo);
        concepto.Descripcion = ClsUtil.cadenaX(catalogo.Descripcion);
        concepto.DescripcionLarga = ClsUtil.cadenaX(catalogo.DescripcionLarga);
        concepto.TipoInsumo = Number(catalogo.Tipo);
        concepto.Unidad = ClsUtil.cadenaX(catalogo.Unidad);
        concepto.Marca = Boolean(Number(filas[10]));
        concepto.IndirectoEspecial = Boolean(Number(filas[11]));
        concepto.PorcentajeIndirectoEspecial = Number(filas[12]);
        concepto.Cantidad = Number(filas[13]);
        concepto.CostoMoneda1 = Number(catalogo.CostoMoneda1);
        concepto.PrecioMoneda1 = Number(filas[15]);
        concepto.CostoMoneda2 = Number(catalogo.CostoMoneda2);
        concepto.PrecioMoneda2 = Number(filas[17]);
        concepto.CodigoAuxiliar = ClsUtil.cadenaX(filas[18]);
        concepto.UrlContenido = catalogo.UrlContenido;
        concepto.PendienteAnalizar = catalogo.PendienteAnalizar;
        concepto.ObservacionPendiente = catalogo.ObservacionPendiente;
        concepto.EsPorcentaje = catalogo.TipoPorcentaje;
        concepto.EsCostoHorario = catalogo.EsCostoHorario;
        conceptosPartidas.push(concepto);
      });
      return conceptosPartidas;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async borrarPptoPartidasConceptos() {
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.pptoSeleccionadoActivo.IdOrganizacion;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'EliminarPresupuestosConceptos');
      // modo offline
      if (!respuesta) {
        return;
      }
      const eliminar: ClsErrores = ClsUtil.parseJSONBig(respuesta);
      if (eliminar?.ErrorDescripcion !== '') {
        throw new Error(eliminar.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async renumerarPptoMatrices(servicio: string) {
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.pptoSeleccionadoActivo.IdOrganizacion;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, servicio);
      // modo offline
      if (!respuesta) {
        return [];
      }
      const renumerar: ClsErrores = ClsUtil.parseJSONBig(respuesta);
      if (renumerar?.ErrorDescripcion !== '') {
        throw new Error(renumerar.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}
